import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Sahayta = lazy(() => import('../components/sahayta/index.js'));
const HelpFaq = lazy(() => import('../components/help-faq/index.jsx'));
const SahaytaCentre = lazy(() => import('../sahaytacentre/index.js'));
const AllTickets = lazy(() => import('../sahaytacentre/AllTickets.js'));
const OrderList = lazy(() => import('../sahaytacentre/OrderList.js'));
const CreateTicket = lazy(() => import('../sahaytacentre/CreateTicket.js'));
const TicketDetails = lazy(() => import('../sahaytacentre/TicketDetails.js'));
const Rating = lazy(() => import('../sahaytacentre/Rating.js'));
const NewSahaytaCentre = lazy(() => import('../sahaytacentre/App'));
const NewCustomerSupport = lazy(() => import('../sahaytacentre/newSahaytaCentre/SupportHome'));
const MereTcikets = lazy(() => import('../sahaytacentre/newSahaytaCentre/MereTicketScreen'));
const MereOrders = lazy(() => import('../sahaytacentre/newSahaytaCentre/MereOrderScrren'));
const OrderRelatedChat = lazy(() => import('../sahaytacentre/OrderRelatedChat'));

const supportRoutes = (
	<>
		<Route path="/sahayta" element={<Sahayta />} />
		<Route path="/help-faq" element={<HelpFaq />} />
		<Route path="/sahayta-centre" element={<SahaytaCentre />} />
		<Route path="/sahayta-centre/all" element={<AllTickets />} />
		<Route path="/orders" element={<OrderList />} />
		<Route path="/sahayta-centre/create" element={<CreateTicket />} />
		<Route path="/sahayta-centre/details" element={<TicketDetails />} />
		<Route path="/sahayta-centre/rating" element={<Rating />} />
		<Route path="/customer-support/home" element={<NewCustomerSupport />} />
		<Route path="/customer-support/tickets" element={<MereTcikets />} />
		<Route path="/customer-support/orders" element={<MereOrders />} />
		<Route path="/customer-support/chat" element={<OrderRelatedChat />} />
		<Route path="/customer-support/guided-flow" element={<NewSahaytaCentre />} />
	</>
);

export default supportRoutes;
